import {
  BrazeCustomEvents,
  BrazePurchaseEvents,
  setLastVisitedEvent,
  changeBrazeUser,
  logCustomEvent,
  logPurchaseEvent,
  setupBrazeUser,
} from './appboy';
import { captureEmailAddressInEmailPrefs, retrieveEmailId } from './gql';

const captureEmailAndSetBrazeUser = async ({
  emailAddress,
  acquisitionChannel,
  isOptedIn = false,
  firstName,
  lastName,
  location,
  phoneNumber,
  shouldResetUserOnCompletion = false,
  onComplete,
  authService,
}) => {
  if (!emailAddress || !acquisitionChannel) {
    throw new Error(
      `Do not have enough data to capture email. Missing ${
        emailAddress ? 'acquisitionChannel' : 'emailAddress'
      }`,
    );
  }

  const primaryIdentityId =
    authService.getUserCookie() || (await authService.getPrimaryIdentityId());

  const emailPrefs = await captureEmailAddressInEmailPrefs(
    emailAddress,
    acquisitionChannel,
    isOptedIn,
    firstName,
    primaryIdentityId,
  );

  if (emailPrefs?.id) {
    await setupBrazeUser({
      brazeUserId: emailPrefs.id,
      firstName,
      lastName,
      location,
      emailAddress,
      primaryIdentityId,
      phoneNumber,
      acquisitionChannel,
      shouldResetUserOnCompletion,
      onComplete,
    });
  }
};

const retrieveEmailAndSetBrazeUser = async (emailAddress) => {
  const id = await retrieveEmailId(emailAddress);

  if (!id) {
    throw new Error(
      `No record exists for ${emailAddress}. It needs to be captured!`,
    );
  }

  changeBrazeUser(id);
};

export {
  BrazeCustomEvents,
  BrazePurchaseEvents,
  setLastVisitedEvent,
  logCustomEvent,
  logPurchaseEvent,
  captureEmailAndSetBrazeUser,
  retrieveEmailAndSetBrazeUser,
};
